import React from 'react';

// Components

import TextInput from '../../../UI/FormInput/TextInput';

export default function JobLocaleTypeFields({formik, index}) { 
    return (
    <>
        {(formik.values?.jobReferences[index]?.address?.tipoInmueble === '1' || formik.values?.jobReferences[index]?.address?.tipoInmueble === '2') ? (
        <>
            <TextInput
                formik={formik}
                fieldName={`jobReferences.${index}.address.piso`}
                label={'Piso'}
                maxLength={5}
                isRequired={true}
            />
        </>
        ) : (formik.values?.jobReferences[index]?.address?.tipoInmueble === '3' || formik.values?.jobReferences[index]?.address?.tipoInmueble === '5') ? (
        <>
            <TextInput
                formik={formik}
                fieldName={`jobReferences.${index}.address.torre`}
                label={'Torre'}
                maxLength={80}
                isRequired={true}
            />

            <TextInput
                formik={formik}
                fieldName={`jobReferences.${index}.address.piso`}
                label={'Piso'}
                maxLength={5}
                isRequired={true}
            />

            <TextInput
                formik={formik}
                fieldName={`jobReferences.${index}.address.apartamento`}
                label={'Apartamento'}
                maxLength={5}
                isRequired={true}
            />
        </>
        ) : (
        <>
            <TextInput
                formik={formik}
                fieldName={`jobReferences.${index}.address.edificio`}
                label={'Edificio'}
                maxLength={80}
                isRequired={true}
            />

            <TextInput
                formik={formik}
                fieldName={`jobReferences.${index}.address.torre`}
                label={'Torre'}
                maxLength={80}
                isRequired={true}
            />

            <TextInput
              formik={formik}
              fieldName={`jobReferences.${index}.address.piso`}
              label={'Piso'}
              maxLength={5}
              isRequired={true}
            />

            <TextInput
                formik={formik}
                fieldName={`jobReferences.${index}.address.oficina`}
                label={'Oficina'}
                maxLength={5}
                isRequired={true}
            />

            <TextInput
                formik={formik}
                fieldName={`jobReferences.${index}.address.local`}
                label={'Local'}
                maxLength={5}
                isRequired={true}
            />
        </>
        )}
    </>
  )
}
